import { render, staticRenderFns } from "./CartIndicator.vue?vue&type=template&id=664e8adc&"
import script from "./CartIndicator.vue?vue&type=script&lang=js&"
export * from "./CartIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShoppingCart: require('/vercel/path0/components/icons/ShoppingCart.vue').default})
